import CreateTariffValidityPart from './CreateTariffValidityPart';

export default CreateTariffValidityPart;
